import React, { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';
import logoIcon from '../../Assets/Icons/logo.png';
import './styles.css';

/**
 * Brief branded animation shown right after the native static launch screen
 * hands off to the WebView. Native-only (web/desktop keep loading straight
 * into the app) — mounted once per app process, so it only ever plays on
 * cold start, not on in-app navigation.
 */
const NativeLaunchAnimation: React.FC = () => {
  const [visible, setVisible] = useState(Capacitor.isNativePlatform());
  const [fadingOut, setFadingOut] = useState(false);

  useEffect(() => {
    if (!visible) return;
    const fadeTimer = setTimeout(() => setFadingOut(true), 1200);
    const hideTimer = setTimeout(() => setVisible(false), 1500);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div className={`native-launch-splash${fadingOut ? ' native-launch-splash--out' : ''}`}>
      <img src={logoIcon} alt="" className="native-launch-splash__logo" />
    </div>
  );
};

export default NativeLaunchAnimation;
